<template>
  <TopNav></TopNav>
  <h1>Karekök Hesaplama</h1>
  <fieldset>
    <legend>Karekök Hesaplama Aracı</legend>
    <label for="k">Sayı: </label><input type="number" v-model.number="inputValue" id="k">
    <br><br>
    {{ inputValue }} sayısının karekökü = <span class="blue">{{ outputValue }}</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Karekok",
  data() {
    return {
      inputValue: 0,
      outputValue: 0
    }
  },
  components: {
    TopNav
  },
  watch: {
    inputValue: function (newValue) {
      let karekok = Math.sqrt(newValue);
      this.outputValue = new Intl.NumberFormat("tr-TR", {
        maximumSignificantDigits: 20
      }).format(karekok);
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 50px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
